import React from 'react'

import { observer } from 'mobx-react'
import queryString from 'query-string'

import { REDIRECT_URL } from 'definitions'
import { replaceUrl } from 'utils'
import Button from 'common/Button'
import MessageList from 'common/MessageList'
import Paper from 'common/Paper'

export default observer(({ ssoStore, loginUrl, loginProvider, logo, location }) => {
  const [loading, setLoading] = React.useState(false)

  const {
    CRUD: { error },
  } = ssoStore

  React.useEffect(() => {
    if (location.search) {
      const searchParams = queryString.parse(location.search)
      if (searchParams.message) {
        ssoStore.setCrudError(searchParams.message)
        replaceUrl(loginUrl)
      } else if (searchParams.autoLogin) {
        handleLogin()
      }
    }
  }, [ssoStore, location.search])

  const handleLogin = async () => {
    setLoading(true)

    const result = await ssoStore.getLoginUrl(loginProvider, {
      returnUrl: sessionStorage.getItem(REDIRECT_URL),
    })
    if (result) {
      if (result.disabled) {
        setLoading(false)
        ssoStore.CRUD.error = 'SSO login is disabled'
      } else {
        window.location = result.redirectUrl
      }
    } else {
      setLoading(false)
    }
  }

  return (
    <Paper
      elevation="3"
      className={`sso-login ${loginProvider} mx-sm-auto col-12 col-sm-10 col-md-7 col-lg-5 col-xl-4`}
    >
      <div className="d-flex flex-column w-100">
        <h2>Login to your account</h2>
        <MessageList messages={error && [error]} hideClose messageClassName="white-space-pre-line" />
        <div className="d-flex align-items-center flex-column">
          <div className="sso-logo mb-7 p-4 rounded">
            <img src={logo} alt={loginProvider} className="sso-logo-img" />
          </div>
          <Button
            outline
            color="default"
            loading={loading}
            disabled={loading}
            className="col-xxl-4 col-md-6 col-12"
            onClick={handleLogin}
          >
            Login
          </Button>
        </div>
      </div>
    </Paper>
  )
})
